import { createReducer, on } from '@ngrx/store';
import * as VehicleActions from '../../actions/master-data/vehicle.actions';
import { VehicleState } from '../../states/master-data/vehicle.state';

export const initialState: VehicleState = { loading: false, error:undefined,  vehicles: [], successMessage: '' };

export const vehicleReducer = createReducer(
    initialState,
    on(VehicleActions.loadVehicles, (state) => ({ ...state, loading: true, error: undefined, successMessage: '' })),
    on(VehicleActions.loadVehiclesSuccess, (state, { vehicles }) => ({ ...state, loading: false, vehicles, error: undefined })),
    on(VehicleActions.addVehicle, (state, { vehicle }) => ({ ...state, vehicles: [...state.vehicles, vehicle], error: undefined })),
    on(VehicleActions.updateVehicle, (state, { vehicle }) => ({
        ...state,
        vehicles: state.vehicles.map(v => v.id === vehicle.id ? vehicle : v),
        error: undefined
    })),
    on(VehicleActions.addVehicleSuccess, (state, { message, vehicle }) => ({
        ...state,
        vehicles: state.vehicles.map(v => v.id === vehicle.id ? vehicle : v),
        successMessage: message,}  )),
    on(VehicleActions.updateVehicleSuccess, (state, { message }) => ({
        ...state,
        successMessage: message ?? 'Vehicle updated successfully'
    })),
    on(VehicleActions.deleteVehicle, (state, { id }) => ({
        ...state,
        vehicles: state.vehicles.filter(v => v.id !== id),
        error: undefined
    })),
    on(VehicleActions.deleteVehicleSuccess, (state, { message, id }) => ({
        ...state, 
        vehicles: state.vehicles.filter(v => v.id !== id),
        successMessage: message ?? 'Vehicle deleted successfully'
    })),
    on(VehicleActions.loadVehiclesFailure, (state, { error }) => ({ ...state, loading: false, error, }))
);